import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X7PushableBlockStore} from '../X7PushableBlockStore';

@observer
export class ReorderContentsControls extends React.Component<{ store: X7PushableBlockStore }> {

  render() {
    const {store} = this.props;

    if (store.reorderContents === null)
      return null;

    const reorderContents = store.reorderContents;
    const isPending = reorderContents.save?.isPending === true;

    return (
      <>
        <div className="row justify-content-end" key="reorder-content-actions">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={() => store.completeReorderContents()}
                    disabled={isPending}>
              Save
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={() => store.cancel()}
                    disabled={isPending}>
              Cancel
            </button>
          </div>
        </div>

        <PromiseMessage label="Saving" state={reorderContents.save} align="right"/>
      </>
    );
  }
}
